import React from 'react';

export type GroupNumber = 'all' | '1' | '2' | '3' | '4' | '5';

export const ABTestContext = React.createContext<{ previewGroup: GroupNumber; testNumber?: number }>({
    previewGroup: '1',
    testNumber: undefined,
});

export const useABTest = () => {
    const context = React.useContext(ABTestContext);

    if (context === undefined) {
        throw new Error('useABTest must be used within an ABTestComponent');
    }

    return context;
};
